import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isChecked',
})
export class IsCheckedPipe implements PipeTransform {
  transform(
    offer = {} as ReplacementOffer,
    comparisonsSelected = [] as ReplacementOffer[]
  ): boolean {
    return !!comparisonsSelected.filter(
      ({ uniqueId }) => uniqueId === offer.uniqueId
    ).length;
  }
}
